import { IconProps } from "../../utils/global-types/global-types";

const ConciseIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9.665 10H2.999a.667.667 0 1 0 0 1.333h6.666a.667.667 0 0 0 0-1.333M15 6.666H3a.667.667 0 0 0 0 1.333h12a.667.667 0 0 0 0-1.333"
    />
  </svg>
);

export default ConciseIcon;
